import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { UserTeams } from '@/shared/enums/user-teams.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const ReferralsListContainer = React.lazy(
  () => import('../../containers/referrals-list/referrals-list.container')
);

const ReferralsAddContainer = React.lazy(
  () => import('../../containers/referrals-add/referrals-add.container')
);

const ReferralsDetailsContainer = React.lazy(
  () => import('../../containers/referrals-details/referrals-details.container')
);

const ReferralsEditContainer = React.lazy(
  () => import('../../containers/referrals-edit/referrals-edit.container')
);

const ReferralTrackingDashboardContainer = React.lazy(
  () => import('../../containers/referral-tracking-dashboard/referral-tracking-dashboard.container')
);

const ReferralFollowUpContainer = React.lazy(
  () => import('../../containers/referral-follow-up/referral-follow-up.container')
);

export const ReferralsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER,
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER,
            UserRole.SALES_QUALITY_AGENT
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsDetailsContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsEditContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: APP_ROUTES.REFERRAL_TRACKING_DASHBOARD_MODULE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.E_COMMERCE_AUTO,
            UserRole.E_COMMERCE_FINANCE,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.MARKETING_EXECUTIVE,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE, UserTeams.RETAIL]}
          component={ReferralTrackingDashboardContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: APP_ROUTES.REFERRAL_FOLLOW_UP_MODULE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.E_COMMERCE_AUTO,
            UserRole.E_COMMERCE_FINANCE,
            UserRole.E_COMMERCE_SERVICE_CENTER,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.MARKETING_EXECUTIVE,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE, UserTeams.RETAIL]}
          component={ReferralFollowUpContainer}
        />
      </React.Suspense>
    )
  }
];
